import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { useDispatch as useStoreDispatch } from "react-redux"
import auth from "./api/authSlice";
import { configurationApi } from "./api/configurationApi";
import { roleApi } from "./api/roleApi";
import { departmentApi } from "./api/departmentApi";
import { employeeApi } from "./api/employeeApi";
import { downloadApi } from "./api/downloadApi";
// List reducers
export const reducer = combineReducers({
    [configurationApi.reducerPath]: configurationApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [departmentApi.reducerPath]: departmentApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    [downloadApi.reducerPath]: downloadApi.reducer,
    auth
})

export type StoreState = ReturnType<typeof reducer>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch

export interface AppThunkProps {
    dispatch: AppDispatch;
    state: StoreState;
    extra?: unknown;
    rejectValue?: unknown;
}

export const useDispatch = () => useStoreDispatch<AppDispatch>()

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ immutableCheck: false })
            .concat(configurationApi.middleware)
            .concat(roleApi.middleware)
            .concat(departmentApi.middleware)
            .concat(employeeApi.middleware)
            .concat(downloadApi.middleware)

})
